export default "__VITE_ASSET__e6a0885a__"